import React, { useState } from "react";
import { UserCog, Loader2, CheckCircle2, Mail } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const ProfileSection = () => {
  const { user, updateProfile } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true); setSaved(false);
    try {
      await updateProfile({ name, phone });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) { /* ignore */ } finally { setSaving(false); }
  };

  return (
    <div>
      <h1 className="font-extrabold italic uppercase tracking-tight text-slate-50 text-2xl md:text-3xl mb-5 flex items-center gap-2"><UserCog size={26} className="text-[#FF3B3B]" /> Mes informations</h1>
      <form onSubmit={save} className="bg-[#10131A] rounded-2xl border border-[#1E232D] p-6 max-w-lg">
        <label className="block text-[14px] font-semibold text-slate-50 mb-1.5">Nom complet</label>
        <input value={name} onChange={(e) => setName(e.target.value)} className="w-full border-2 border-[#222735] rounded-lg px-3 py-3 mb-4 outline-none focus:border-[#E01F1F] text-slate-50" />

        <label className="block text-[14px] font-semibold text-slate-50 mb-1.5">Adresse email</label>
        <div className="flex items-center border-2 border-[#1E232D] bg-[#181C26] rounded-lg px-3 mb-4">
          <Mail size={18} className="text-slate-500" />
          <input value={user?.email || ""} disabled className="flex-1 px-3 py-3 bg-transparent outline-none text-slate-400" />
        </div>

        <label className="block text-[14px] font-semibold text-slate-50 mb-1.5">Téléphone</label>
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="06 12 34 56 78" className="w-full border-2 border-[#222735] rounded-lg px-3 py-3 mb-5 outline-none focus:border-[#E01F1F] text-slate-50" />

        <div className="flex items-center gap-3">
          <button type="submit" disabled={saving} className="btn-orange rounded-lg px-6 py-3 font-bold flex items-center justify-center gap-2 disabled:opacity-70">
            {saving && <Loader2 className="animate-spin" size={18} />} Enregistrer
          </button>
          {saved && <span className="text-emerald-400 flex items-center gap-1.5 text-[14px] font-semibold"><CheckCircle2 size={16} /> Enregistré</span>}
        </div>
      </form>
    </div>
  );
};

export default ProfileSection;
